import { render } from "./TabConfigClassifications.vue?vue&type=template&id=0de635e3"
import script from "./TabConfigClassifications.vue?vue&type=script&lang=js"
export * from "./TabConfigClassifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__